import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useSelector } from 'react-redux';

// Legal
// ==========================================
// Legal: Common
import './legal.scss';
import Navbar from './_common/navbar';
import Footer from './_common/footer';

// Legal: Views
import {Privacy} from './privacy';
import {Terms} from './terms';

export const Legal = () => {
    const router = useSelector(state => state.router);

    return (
		<div className="layout">
            <h1 className="sr-only visually-hidden">Assist@</h1>
			<Navbar location={router.location} />
            <Switch>
                <Route path="/legal/privacy" component={Privacy} />
                <Route path="/legal/terms" component={Terms} />

                <Route render={() => {
                    return <Redirect exact to="/legal/terms" />
                }} />
            </Switch>
            <Footer location={router.location} />
		</div>
    )
}